const zxcvbn = (password, userData) => {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: euPortalConfig.euapi_base_uri+'password_strength/',
            type: 'POST',
            data: JSON.stringify({
                password: password,
                userData: userData
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: (response) => {
                resolve(response.data);
            },
            error: (error) => {
                reject(false);
            }
        });
    });
}

export default zxcvbn;
